var vehicle = (function () {
    "use strict";
    ///
    /// Constants
    ///
    var vehicleActivatedEventName = 'vehicle-activated';
    var vehicleSelectButtonDataAttribute = 'vehicle-select';
    var vehicleClearButtonDataAttribute = 'vehicle-clear';
    var emptyVehicleSelection = Object.freeze({
        VehicleConfigurationID: undefined,
        VehicleTireOptionID: undefined,
        OverSizeTireRange: undefined
    });

    /**
     * @typedef {object} VehicleSelectionData
     * @prop {string} VehicleConfigurationID The ID of the selected VehicleConfiguration
     * @prop {string} VehicleTireOptionID    The ID of the selected VehicleTireOption
     * @prop {string} OverSizeTireRange      The size range in inches of oversized tire search
     */

    ///
    /// First run functions
    ///
    initialize();

    ///
    /// External interface 
    ///
    return {
        activate: activateVehicle,
        select: startNewVehicleSelection,
        clear: clearVehicleSelection
    };
    
    /**
     * Triggers the activation event for a selected vehicle
     * @param {VehicleSelectionData} vehicleSelection The selected vehicle to trigger the activation event for
     * @param {(vehicleSelection:VehicleSelectionData)=>void} callback A function to call after the event is triggered
     */
    function triggerActivationEvent(vehicleSelection, callback) {

        var vehicleDescription = null;
        var fitmentProfile = null;

        var batch = ridestyler.ajax.batch();
        batch.done(function(r) {
            var event = $.Event(vehicleActivatedEventName);
            
            $.extend(event, vehicleSelection, { 
                VehicleDescription: vehicleDescription,
                FitmentProfile: fitmentProfile,
                OverSizeTireRange: vehicleSelection.OverSizeTireRange
            });
    
            $(document.body).trigger(event, [vehicleSelection, vehicleDescription, fitmentProfile]);
    
            if (typeof callback === 'function')
                callback(vehicleSelection);
        });
            

        if (vehicleSelection.VehicleConfigurationID)
        {
            if (vehicleSelection.VehicleTireOptionID) {
                var cachedProfile = null;
                try {
                    cachedProfile = JSON.parse(localStorage.getItem('cached-vehicle-profile'));
                }catch(ex) { }

                if (!cachedProfile || cachedProfile.TireOption.TireOptionID != vehicleSelection.VehicleTireOptionID)
                {
                    batch.send('fitment-result', {
                        action: 'Vehicle/GetFitmentProfile',
                        data: {
                            ConfigurationID: vehicleSelection.VehicleConfigurationID,
                            TireOptionID: vehicleSelection.VehicleTireOptionID
                        },
                        callback: function(r) {
                            if (r.Success) {
                                localStorage.setItem('cached-vehicle-profile', JSON.stringify(fitmentProfile = r.Profile));
                            }
                        }
                    });
                } else {
                    fitmentProfile = cachedProfile;
                }
            }

            var cachedVehicle = null;
            try {
                cachedVehicle = JSON.parse(localStorage.getItem('cached-vehicle'));
            } catch (ex) { }

            if (!cachedVehicle || cachedVehicle.ConfigurationID != vehicleSelection.VehicleConfigurationID)
            {
                batch.send('config-result', {
                    action: 'Vehicle/GetDescriptions',
                    data: {
                        VehicleConfiguration: vehicleSelection.VehicleConfigurationID
                    },
                    callback: function(r) {
                        if (r.Success && r.Descriptions.length > 0) {
                            localStorage.setItem('cached-vehicle', JSON.stringify(vehicleDescription = r.Descriptions[0]));
                        }
                    }
                });
            }
            else {
                vehicleDescription = cachedVehicle;
            }
        }

        batch.execute();
    }

    /**
     * Activates a vehicle as the selected vehicle
     * @param {VehicleSelectionData} vehicleSelection The selected vehicle to activate
     * @param {(vehicleSelection:VehicleSelectionData)=>void} callback A function to call when the activation set and optionally persisted
     * @param {boolean} [persist=true] Whether or not we want to persist the selection on the server-side
     */
    function activateVehicle (vehicleSelection, callback, persist) {
        if (typeof persist === 'undefined' || persist) {
            // If we're persisting the activation, send it off to the server before broadcasting the activation event
            $.getJSON("/BrowsingSession/Vehicle/New", {
                VehicleConfiguration: vehicleSelection.VehicleConfigurationID,
                VehicleTireOption: vehicleSelection.VehicleTireOptionID
            }, function () {
                activateVehicle(vehicleSelection, callback, false);
            });

            return;
        }

        triggerActivationEvent(vehicleSelection, callback);
    }

    /**
     * Open a modal for the user to select a new vehicle
     * @param {(vehicleSelection:VehicleSelectionData)=>void} callback A function to call after the vehicle has been selected and the activated event has been triggered
     * @param {boolean} [persist=true] Whether or not to persist the selected vehicle server-side
     */
    function startNewVehicleSelection(callback, persist) {
        new RideStylerVehicleSelectionModal({
            IncludeOETireOption: true,
            DefaultVehicleSelectParameters: {
                Options: 2
            },
            callback: function (data) {
                // Do nothing if a selections not made
                if (!data.FinalSelectionMade) return;

                // The selected vehicle from the VSM
                var vehicle = data.Vehicle;

                // The event to output to consumers
                var selectionData = Object.freeze({
                    VehicleConfigurationID: vehicle.VehicleConfiguration,
                    VehicleTireOptionID:    vehicle.TireOptionID
                });
                
                activateVehicle(selectionData, callback, persist);
            }
        }).Show();        
    }

    /**
     * Clear the selected vehicle
     * @param {(vehicleSelection:VehicleSelectionData)=>void} callback A function to call after the selection has been cleared and the activated event has been triggered
     * @param {boolean} [persist=true] Whether or not to persist the clear server-side
     */
    function clearVehicleSelection(callback, persist) {
        if (typeof persist === 'undefined' || persist) {
            // If we're persisting the activation, send it off to the server before broadcasting the activation event
            $.getJSON("/BrowsingSession/Vehicle/Clear", function () {
                triggerActivationEvent(emptyVehicleSelection, callback);
            });

            return;
        }
        
        triggerActivationEvent(emptyVehicleSelection, callback);
    }

    /**
     * @param {string} search
     * @param {string[]} parametersToExclude 
     */
    function removeSearchParameters(search, parametersToExclude) {
        var newParams = [];
        var searchParams = (search || '').split('&');

        if (!parametersToExclude || !parametersToExclude.length) return;

        for (var i = 0; i < parametersToExclude.length; i++) {
            parametersToExclude[i] = parametersToExclude[i].toLowerCase();
        }


        for (var i = 0; i < searchParams.length; i++) {
            var p = searchParams[i];
            var k = p.split('=', 1)[0].toLowerCase();

            if (!parametersToExclude.indexOf(k)) {
                newParams.push(p);
            }
        }

        return newParams.length ? '?' + newParams.join('&') : '';
    }

    /**
     * Handles a successful clear/activation from the data selection attribute element event handlers
     * @param {HTMLElement} target The target of the click event
     */
    function handleSelectionEventCallback(target) {
        if (target.href) location.href = target.href;
        else if (typeof $(target).data('refresh') !== 'undefined') {
            var search = removeSearchParameters(location.search, [
                'pagenumber',
                'filters',
                'cfilters',
                'specs'
            ]);

            var newUrl = location.origin + location.pathname + search;

            if (newUrl != location.href) location.href = newUrl;
            else location.reload(true);
        }
    }
    
    function initialize() {
        $(document.body)
            .find('[data-href]').attr('href', function () { return $(this).attr('data-href'); }).end()
            .on('click', '[data-' + vehicleSelectButtonDataAttribute + ']', function(e) {
                // If this is a link we don't want the user redirected until we say so
                e.preventDefault();

                startNewVehicleSelection(function () {
                    handleSelectionEventCallback(e.target);
                });
            })
            .on('click', '[data-' + vehicleClearButtonDataAttribute + ']', function (e) {
                // If this is a link we don't want the user redirected until we say so
                e.preventDefault();

                clearVehicleSelection(function () {
                    handleSelectionEventCallback(e.target);
                });
            });
    }
})();